/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import bbox from "@turf/bbox";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

class LAYER_AI extends Component {
  state = {};

  componentDidUpdate(prevProps) {
    if (
      this.props.ai_preset_reducer.ai_preset_update_layer !==
      prevProps.ai_preset_reducer.ai_preset_update_layer
    ) {
      this.on_render();
    }

    if (
      this.props.ai_preset_reducer.ai_preset_update_fly !==
      prevProps.ai_preset_reducer.ai_preset_update_fly
    ) {
      this.on_fly();
    }
  }

  on_render = async () => {
    try {
      const { map_object } = this.props.layer;
      if (!map_object) return;
      const layer_query_list =
        this.props.ai_preset_reducer?.layer_query_list || [];
      layer_query_list.forEach((layer) => {
        const layer_id = layer?.layer_id?._id;
        const type = layer?.layer_id?.type;
        const features = layer?.features || [];

        //Point || MultiPoint --> circle
        //LineString || MultiLineString --> line
        //Polygon || MultiPolygon --> fill

        const geojson = {
          type: "FeatureCollection",
          features: features,
        };
        if (!map_object.getSource(layer_id)) {
          map_object.addSource(layer_id, {
            type: "geojson",
            data: geojson,
          });
        } else {
          map_object.getSource(layer_id).setData(geojson);
        }

        let paint = {};
        const paint_object = layer?.style_object?.paint_object;
        if (paint_object) {
          paint = layer.style_object.paint_object;
        }

        if (!map_object.getLayer(layer_id)) {
          let type_shape;
          if (type === "Point" || type === "MultiPoint") {
            type_shape = "circle";
          } else if (type === "LineString" || type === "MultiLineString") {
            type_shape = "line";
          } else if (type === "Polygon" || type === "MultiPolygon") {
            type_shape = "fill";
          }

          map_object.addLayer({
            id: layer_id,
            type: type_shape,
            source: layer_id,
            paint,
            layout: {
              visibility: "visible",
            },
          });
        } else {
          for (const key in paint) {
            if (paint.hasOwnProperty(key)) {
              map_object.setPaintProperty(layer_id, key, paint[key]);
            }
          }
        }
      });
    } catch (error) {}
  };

  on_fly = async () => {
    try {
      const { map_object } = this.props.layer;
      if (!map_object) return;
      const layer_query_list =
        this.props.ai_preset_reducer?.layer_query_list || [];
      let features = [];

      layer_query_list.forEach((layer) => {
        const layer_features = layer?.features || [];
        features = [...features, ...layer_features];
      });

      if (features?.length > 0) {
        const geojson = {
          type: "FeatureCollection",
          features: features,
        };

        const [minLng, minLat, maxLng, maxLat] = bbox(geojson);
        let padding = { top: 50, bottom: 50, left: 50, right: 400 };

        map_object.fitBounds(
          [
            [minLng, minLat],
            [maxLng, maxLat],
          ],
          {
            padding,
            maxZoom: this.props.layer.max_zoom,
          }
        );
      }
    } catch (error) {}
  };

  render() {
    return <main></main>;
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  ai_preset_reducer: state.ai_preset_reducer,
});

export default connect(mapStateToProps, {})(LAYER_AI);
